import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentCard = ({ document }) => {
  const getFileIcon = (type) => {
    const icons = {
      'pdf': 'FileText',
      'doc': 'FileText',
      'docx': 'FileText',
      'xls': 'FileSpreadsheet',
      'xlsx': 'FileSpreadsheet',
      'ppt': 'Presentation',
      'pptx': 'Presentation',
      'zip': 'FileArchive',
      'image': 'Image'
    };
    return icons?.[type] || 'File';
  };

  const getFileColor = (type) => {
    const colors = {
      'pdf': 'bg-error/10 text-error',
      'doc': 'bg-primary/10 text-primary',
      'docx': 'bg-primary/10 text-primary',
      'xls': 'bg-success/10 text-success',
      'xlsx': 'bg-success/10 text-success',
      'ppt': 'bg-warning/10 text-warning',
      'pptx': 'bg-warning/10 text-warning',
      'zip': 'bg-secondary/10 text-secondary',
      'image': 'bg-accent/10 text-accent'
    };
    return colors?.[type] || 'bg-muted text-muted-foreground';
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024)?.toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024))?.toFixed(1)} MB`;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-all duration-300">
      <div className="flex items-start gap-3 mb-3">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${getFileColor(document?.type)}`}>
          <Icon name={getFileIcon(document?.type)} size={20} className="md:w-6 md:h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-1 mb-1">
            {document?.name}
          </h4>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="uppercase">{document?.type}</span>
            <span>•</span>
            <span>{formatFileSize(document?.size)}</span>
          </div>
        </div>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Calendar" size={12} className="flex-shrink-0" />
          <span>Uploaded: {document?.uploadDate}</span>
        </div>
        {document?.category && (
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Tag" size={12} className="flex-shrink-0" />
            <span>{document?.category}</span>
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" fullWidth iconName="Download" iconPosition="left">
          Download
        </Button>
        <Button variant="ghost" size="sm" iconName="Eye" className="flex-shrink-0">
          <span className="sr-only">Preview</span>
        </Button>
      </div>
    </div>
  );
};

export default DocumentCard;